// Route Groups
import VerificationRoutes from './verification'
import ForgotPasswordRoutes from './forgotPassword'

// Route Pages
const CleverTapEmailVerification = () => import('../../components/common/pages/CleverTapEmailVerification.vue')
const Login = () => import('../../components/common/pages/Login.vue')
const NetworkError = () => import('../../components/common/pages/NetworkError.vue')
const Register = () => import('../../components/common/pages/Register.vue')

// Route Parents
const GenericParent = () => import('../../components/common/pages/GenericParent.vue')

export default () => {
  return [
    {
      path: '',
      name: 'Login',
      component: Login,
      props: true
    },
    {
      path: 'NetworkError',
      name: 'NetworkError',
      component: NetworkError,
      props: true
    },
    {
      path: 'Register',
      name: 'Register',
      component: Register,
      props: true
    },
    {
      path: 'CleverTapEmailVerification',
      name: 'CleverTapEmailVerification',
      component: CleverTapEmailVerification,
      props: true
    },
    {
      path: 'Verification',
      component: GenericParent,
      meta: { flow: 'Verification' },
      props: true,
      children: VerificationRoutes()
    },
    {
      path: 'ForgotPassword',
      component: GenericParent,
      props: true,
      meta: { flow: 'ForgotPassword' },
      children: ForgotPasswordRoutes()
    }
  ]
}
